export default __webpack_public_path__ + "static/media/icon-suhyup@3x.0f200bf9.png";